export const selectPropertyReducer = (state, action) => {
  state.selectedProperty = action.payload;
};

export const setPropertyPreviewReducer = (state, action) => {
  const { id, preview } = action.payload;

  const property = state.allProperties.value.find((item) => item.id === id);

  if (property) {
    property.preview = preview;
  }
};

export const clearSearchResultsReducer = (state) => {
  state.searchProperties.value = [];
  state.searchProperties.next = null;
  state.searchProperties.loading = false;
};
